import React from 'react';
import CordBlood from '../assets/img/cord-blood.jpg';
import CordBlood1 from '../assets/img/cord-blood-1.jpg';
import Footer1 from '../components/Footer1';
import Header1 from '../components/Header1';

function CordBloodBankingKits() {
    return (
        <>
            <Header1 />
                <section className='blog-wrapper news-wrapper section-padding'>
                    <div className='container'>
                        <div className='row'>
                        <div className="col-md-12">
                                <div className="news-content">
                                    <div className="section-heading marginbot20">
                                        <p className='mb-0'><strong>Cord</strong>  Blood banking </p><h5></h5><p className='mb-3'></p>
                                    </div>
                                    <div className='row'>
                                        <div className="col-md-3">
                                            <img src={CordBlood} className="alignleft" alt="" style={{height:"200px", width:"200px"}} />
                                        </div>
                                        <div className="col-md-3">
                                            <img src={CordBlood1} className="alignleft" alt=" "  style={{height:"200px", width:"200px"}} />
                                        </div>
                                        <div className="col-md-6" style={{ float: "left",
                                                                            borderLeft: "1px",
                                                                            borderStyle: "dotted",
                                                                            borderRight: "none",
                                                                            borderTop: "none",
                                                                            borderBottom: "none",
                                                                            paddingBottom: "7%"
                                        }}>
                                            <br />
                                            <p className='mb-3'>
                                                Cord blood banking is the process of collecting and storing new born’s umbilical cord stem cells for potential medical use. Our approach to cord blood and tissue banking is to provide the most advanced science and technology to collect, process and store stem cells from cord blood to deliver the highest-quality stem cells in order to achieve the best results.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            <Footer1 />
        </>
    );
}

export default CordBloodBankingKits;
